import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { AgreeDisagreeQuestionResultBarChartComponent } from "app/frontend/lib/timeline/timeline-item/poll-result/agree-disagree-poll-result/agree-disagree-poll-result-bar-chart/agree-disagree-question-result-bar-chart.component";
import { ClosedQuestionResultBarChartComponent } from "app/frontend/lib/timeline/timeline-item/poll-result/closed-poll-result/closed-question-result-bar-chart/closed-result-bar-chart.component";
import { PollResult } from "app/frontend/lib/timeline/timeline-item/poll-result/poll-result.type";
import { PollType } from "../../polls.type";
import { ScalePollResultPyramidChartComponent } from "app/frontend/lib/timeline/timeline-item/poll-result/scale-poll-result/scale-question-result-pyramid-chart/scale-question-result-pyramid-chart.component";

import { TranslateModule } from "@ngx-translate/core";
import { FiveStarsQuestionResultChartComponent } from "./five-stars-question-result-chart/five-stars-question-result-chart.component";

@Component({
    selector: 'poll-results-chart',
    templateUrl: './poll-results-chart.component.html',
    styleUrls: ['./poll-results-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule,
    AgreeDisagreeQuestionResultBarChartComponent,
    ClosedQuestionResultBarChartComponent,
    ScalePollResultPyramidChartComponent,
    FiveStarsQuestionResultChartComponent
]
})
export class PollResultsChartComponent {
   
    @Input() results: PollResult
    @Input() pollType: PollType
    @Input() pollId: string
    @Input() context: string

    constructor(
    ) { }

}